// types
import { type ModuleType as Event } from "./_definitions"
import { type State } from "../../types"

export const eventSelector = (state: State): Event => state.event
